module.exports = __webpack_public_path__ + "img/enotas.2ecebd55.png";